import * as Yup from "yup";

export const gmcFormScheme = Yup.object().shape({
  insurer: Yup.string().required("*Required"),
  dependent_type: Yup.string().required("*Required"),
  maternity_coverage: Yup.string().required("*Required"),
  disease_wise_limit: Yup.string().required("*Required"),
  utilization_limit_for_parents: Yup.string().required("*Required"),
  waiting_period: Yup.string().required("*Required"),
  corporate_buffer:Yup.string().required("*Required"),
  premium_contribution:Yup.string().required("*Required"),
  ambulance_limit:Yup.string().required("*Required"),
  co_pay: Yup.string().required("*Required"),
  opd_included: Yup.string().required("*Required"),
  room_limit: Yup.string().required("*Required"),
  sum_insured: Yup.string().required("*Required"),
  wellness_benefits_options: Yup.string().required("*Required"),
  // metro_normal:Yup.string().when('room_limit', {
  //   is: (value) => value === 'Customise Limit (by metro & Non metro)', // condition to check
  //   then: Yup.string().required('*Required')
  // }), 
  // metro_icu:Yup.string().when('room_limit', {
  //   is: (value) => value === 'Customise Limit (by metro & Non metro)', // condition to check
  //   then: Yup.string().required('*Required')
  // }), 
  // non_metro_normal:Yup.string().when('room_limit', {
  //   is: (value) => value === 'Customise Limit (by metro & Non metro)', // condition to check
  //   then: Yup.string().required('*Required')
  // }),
  // non_metro_icu:Yup.string().when('room_limit', {
  //   is: (value) => value === 'Customise Limit (by metro & Non metro)', // condition to check
  //   then: Yup.string().required('*Required')
  // }),
  // metro_normal_delivery: Yup.string().when('maternity_coverage', (maternityCoverage, schema) => {
  //   if (maternityCoverage === true) {
  //     return schema.required('*Required');
  //   }
  //   return schema;
  // }),
  // metro_icu_maternity:Yup.string().when('maternity_coverage', (maternityCoverage, schema) => {
  //   if (maternityCoverage === true) {
  //     return schema.required('*Required');
  //   }
  //   return schema;
  // }),
  // non_metro_normal_delivery_limit:Yup.string().when('maternity_coverage', (maternityCoverage, schema) => {
  //   if (maternityCoverage === true) {
  //     return schema.required('*Required');
  //   }
  //   return schema;
  // }),
  // non_metro_icu_limit:Yup.string().when('maternity_coverage', (maternityCoverage, schema) => {
  //   if (maternityCoverage === true) {
  //     return schema.required('*Required');
  //   }
  //   return schema;
  // }),
  // baby_coverage_limit:Yup.string().when('maternity_coverage', (maternityCoverage, schema) => {
  //   if (maternityCoverage === true) {
  //     return schema.required('*Required');
  //   }
  //   return schema;
  // }),

  // disease_name:Yup.string().when('disease_wise_limit', {
  //   is: (value) => value === "Yes", // condition to check
  //   then: Yup.string().required('*Required')
  // }),
  // disease_eligibility_criteria:Yup.string().when('disease_wise_limit', {
  //   is: (value) => value === "Yes", // condition to check
  //   then: Yup.string().required('*Required')
  // }),
  // disease_limit:Yup.string().when('disease_wise_limit', {
  //   is: (value) => value === "Yes", // condition to check
  //   then: Yup.string().required('*Required')
  // }),


  // co_pay_condition:Yup.string().when('co_pay', {
  //   is: (value) => value === "For All" || value === 'Only For Parents', // condition to check
  //   then: Yup.string().required('*Required')
  // }),

  // opd_limit: Yup.string().when('opd_included', (opdIncluded, schema) => {
  //   if (opdIncluded === true) {
  //     return schema.required('*Required');
  //   }
  //   return schema;
  // }),

  corporate_buffer_limit: Yup.string().when('corporate_buffer', (corporateBuffer, schema) => {
    if (corporateBuffer === true) {
      return schema.required('*Required');
    }
    return schema;
  }),
});


export const gpaGtlSchema = Yup.object().shape({
  insurer: Yup.string().required("*Required"),
  sum_insured: Yup.string().required("*Required"),
  amount_per_mil: Yup.string().nullable(),
  commission: Yup.string().when('sum_insured', {
    is: (value) => value === 'FLAT', // condition to check
    then: Yup.string().required('*Required')
  }), 
  sum_insured_multipliers: Yup.array()
});

export const gpaGtlInitialValues = {
  insurer: "",
  sum_insured: "",
  commission: "",
  attribute_definition_mapping: {},
  amount_per_mil: null,
  sum_insured_multipliers: []
};

export const gmcInitialValues = {
  insurer: "",
  dependent_type:"",
  maternity_coverage:"",
  utilization_limit_for_parents:"",
  co_pay:"",
  waiting_period:"",
  opd_included:"",
  premium_contribution:"",
  ambulance_limit:"",
  corporate_buffer:"",
  disease_wise_limit:"",
  disease_wise_limit_detail: [{
    disease_name: "",
    disease_eligibility_criteria: "",
    disease_limit: "",
  }],
  room_limit: "",
  sum_insured: "",
  wellness_benefits_options: "",
  metro_normal:"",
  co_pay_condition:"",
  metro_icu:'',
  non_metro_normal:"",
  non_metro_icu:"",
  metro_normal_delivery:"",
  metro_icu_maternity:"",
  non_metro_normal_delivery_limit:"",
  non_metro_icu_limit:"",
  baby_coverage_limit:"",
  // disease_name:"",
  // disease_eligibility_criteria:"",
  // disease_limit:"",
  opd_limit:"",
  corporate_buffer_limit:"",
  wellness_benefits:[],
  maternity_coverage_limit: true,
  customized_room_limit: true,
  disease_wise_refer_policydoc: true,
};
